import i18n from '../../../../i18n';
import { defineAsyncComponent, reactive } from 'vue';
import store from '../../../../store/index';
import {
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from '../../../../utils/button';
import { createAppPageHeaderTop, createManageDelete, createManageExportCsv, createPage } from '../../../../utils/page';
import {
    initUseForm,
    onClickActive,
    onClickArchive,
    onClickCreate,
    onClickDelete,
    onClickDeleteAllClient,
    onClickEdit,
    onClickView
} from '../../../../utils/form';

import { has } from '../../../../utils/menu-context';
import {
    createColumnInlineCheckbox,
    createColumnInput,
    createColumnSelect
} from '../../../../components/table/c-table.logic';
import { addModal, setIsLoading as setIsLoadingApp } from '../../../../app.logic';
import { createLoading } from '../../../../utils/loading';
import { Button, Col, Form, Input, Modal, Row, Skeleton } from 'ant-design-vue';
import { useForm as createUseForm } from '@ant-design-vue/use';
import { setAppPageHeader } from '../../../../components/layout/app-layout/app-layout.logic';
import {
    callActive,
    callArchive,
    callDelete,
    onClickSave
} from '../../sampling/sampling-product/sampling-product.logic';
import { clearRulesStartsWith } from '../../../../utils/validate';
import lodash from 'lodash';
import { modalStyleIFrame } from '../../../../utils/constant';
// import { openModalForm as openModalAnalysisTopicStandardForm } from "./analysis-topic-standard.logic"
import { openModalForm as openModalFormOperator } from '../../master-mgt/lab/operator-form/operator-form.logic';
import { callSearchAllLabTopicByProductIdAndCounties } from "../sampling-product-analysis/analysis.logic";
// import { callLookupByGroupName } from '../../master-mgt/lab/product-grouping/product-grouping.logic';

const CIcon = defineAsyncComponent(() => import('../../../../components/icon/CIcon'));
const CIFrame = defineAsyncComponent(() => import('../../../../components/iframe/CIFrame'));
// const CSelect = defineAsyncComponent(() => import('../../../../components/input/template-builder/select/CSelect'));
const InputNumber = defineAsyncComponent({
    loader: () => import('../../../../components/input/template-builder/input-number/InputNumber'),
    loadingComponent: Skeleton
});

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = 'resource/v1/transaction/samplingProductAnalysisTopic';
export const routerPrefix = 'sampling-product-analysis-topics';

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const createFormTitle = () => {
    return i18n.global.t('button.create');
};

export const createForm = (form = {}) => {
    return lodash.merge({
        refSamplingProductAnalysis: null,
        refLabTopic: null,
        refAttachment: null,
        isTransfer: null,
        isManualStd: null,
        sub: null,
        refTopicAnalysisStatus: null,
        refParent: null,
        refTransferFrom: null,
        inputs: []
    }, form);
};

export const createFormInput = (form = {}) => {
    return {
        subSeq: null,
        realValue: null,
        displayValue: null,
        ...form
    };
};

export const createRules = () => {
    return {};
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ['**'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        };
    }
};

export const clearTempProperTies = ({ analysisTopic }) => {
    delete analysisTopic.n;
    delete analysisTopic.c;
    delete analysisTopic.m;
    delete analysisTopic.mUpper;
    delete analysisTopic.mathSymbol;
    delete analysisTopic.operatorValue;
    delete analysisTopic.isAccept;
    delete analysisTopic.isDetected;
};

export const upsertCountryResults = ({ analysisTopic, input, parent }) => {
    if (parent && analysisTopic) {
        let countExportCountry = 1;
        // countExportCountry = parent?.refSamplingProduct?.refCountry1 ? ++countExportCountry : countExportCountry;
        countExportCountry = parent?.refSamplingProduct?.refCountry2 ? ++countExportCountry : countExportCountry;
        if ((!input.results || input.results.length == 0) && countExportCountry > 0) {
            if (!input?.results) {
                input.results = [];
            }
            for (let i = 0; i < countExportCountry; ++i) {
                const result = reactive({});
                result.stdLabFormula = analysisTopic?.refLabTopic?.refLabFormula?.key;
                result.stdN = analysisTopic.n;
                result.stdC = analysisTopic.c;
                result.stdM = analysisTopic.m;
                result.stdMBig = analysisTopic.mUpper;
                result.stdMathSymbol = analysisTopic.mathSymbol;
                result.stdMathValue = analysisTopic.operatorValue;
                result.stdIsAccept = analysisTopic.isAccept;
                result.stdIsDetect = analysisTopic.isDetected;
                result.refCountry = lodash.cloneDeep(parent.refSamplingProduct[`refCountry${i + 1}`]);
                input.results.push(result);
                input.isSave = true;
            }
        } else if (input.results?.length > 0 && !input.isDelete) {
            const updateResultData = {
                isSave: true,
                stdN: analysisTopic.n,
                stdC: analysisTopic.c,
                stdM: analysisTopic.m,
                stdMBig: analysisTopic.mUpper,
                stdMathSymbol: analysisTopic.mathSymbol,
                stdMathValue: analysisTopic.operatorValue,
                stdIsAccept: analysisTopic.isAccept,
                stdIsDetect: analysisTopic.isDetected
            };
            input.results?.forEach(exitResultData => lodash.merge(exitResultData, updateResultData));
            input.isSave = true;
        } else if (input.results?.length > 0 && input.isDelete) {
            input.results?.forEach(exitResultData => exitResultData.isDelete = true);
            input.isSave = true;
        }
    }
};

/*
export const generateTopicInputWithResults = ({ data, parent }) => {
    data.forEach(analysisTopic => {
        if (!analysisTopic.id) {
            analysisTopic.isShowReport = true;
        }
        if (!analysisTopic.sub) {
            analysisTopic.sub = analysisTopic.refLabTopic?.sub;
        }
        const sub = analysisTopic.sub || 0;
        if (analysisTopic.inputs.length <= sub) {
            for (let i = 0; i < sub; i++) {
                const subIndex = i + 1;
                const exist = analysisTopic.inputs.find(d => d.subSeq === subIndex);
                if (!exist) {
                    analysisTopic.inputs.splice(i, 0, createFormInput({ subSeq: subIndex }));
                    generateTopicInputResults({ analysisTopic: analysisTopic, input: analysisTopic.inputs[i], parent });
                }
            }
        } else if (analysisTopic.inputs.length > sub) {
            analysisTopic.inputs.splice(sub, analysisTopic.inputs.length - sub);
        }
        clearTempProperTies({ analysisTopic })
    });
};
*/

export const generateTopicInputWithResults = ({ data, parent }) => {
    data.forEach(analysisTopic => {
        const sub = analysisTopic.sub || 0;
        const skipLength = analysisTopic?.inputs?.filter(input => input.isDelete == true).length;
        const activeLength = analysisTopic?.inputs?.length - skipLength;
        if (activeLength < sub) {
            for (let i = activeLength; i < sub; i++) {
                analysisTopic?.inputs?.splice(i, 0, createFormInput({ subSeq: i + 1 }));
                if (analysisTopic.isManualStd && !parent?.refExtCenterType) {
                    upsertCountryResults({ analysisTopic: analysisTopic, input: analysisTopic.inputs[i], parent });
                }
            }
        } else if (activeLength > sub) {
            for (let i = analysisTopic.inputs.length - (skipLength + 1); i >= sub; i--) {
                analysisTopic.inputs[i].isDelete = true;
                upsertCountryResults({ analysisTopic: analysisTopic, input: analysisTopic.inputs[i], parent });
            }
        }
    });
};

export const openModalForm = ({ bind, props, analysis, isShowOnlyAttachment }) => {
    const analysisId = analysis?.id;
    const extCenterTypeKey = analysis?.refExtCenterType?.key;
    const labType = lodash.kebabCase(props.refLabTypeKey || analysis?.refLabType?.key);
    const urlPath = extCenterTypeKey === 'Cross Center' ? `/${labType}/analysis-cross-centers/${analysisId}/view` :
        extCenterTypeKey === 'Lab Ext' ? `/lab-ext/${labType}-sampling-product-analysiss/${analysisId}/view`  : ''
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => <CIFrame
            src={`${process.env.VUE_APP_PUBLIC_PATH}/app${urlPath}?isLayout=false&canCreate=false${isShowOnlyAttachment?'&isShowOnlyAttachment=true':''}`}></CIFrame>
    });
    return options;
};

export const createColumns = ({ props }) => {
    const { viewOnly, parent, refLabTypeKey, useForm, refExtCenterTypeKey, repeatOption } = props;
    const { modelRef } = useForm;
    return [
        createColumnSelect({
            title: () => i18n.global.t('model.topic.modelName'),
            dataIndex: 'refLabTopic.name',
            customRender: ({ record }) => <div>
                <span>{record?.refLabTopic?.name} {record?.refLabTopic?.refLabTopicUnit?.value}</span>
                <span>({record?.refLabTopic?.nameS} {record?.refLabTopic?.refLabTopicUnit?.value})</span>
            </div>,
            search: { name: 'refLabTopic.id' }
            // customRender: ({ record }) => {
            //     const index = modelRef.topics?.findIndex(d => d === record);
            //     const key = `topics.${index}.refLabTopic`;
            //     return record?.id ?
            //         <div class="px-3">{record?.refLabTopic?.name} {record?.refLabTopic?.refLabTopicUnit?.value}</div> :
            //         <Form.Item {...useForm.validateInfos[key]} wrapperCol={{ xs: 24 }}>
            //             <CSelect value={record.refLabTopic}
            //                      onUpdate:value={(value) => {
            //                          record.isSave = true;
            //                          record.refLabTopic = value;
            //                          generateTopicInputWithResults({ data: [record] });
            //                          clearTempProperTies({ analysisTopic });
            //                      }}
            //                      list={({ searchQuery }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', {
            //                          searchQuery,
            //                          labTypeKey: refLabTypeKey,
            //                          where: [{
            //                              name: 'id',
            //                              type: 'UUID',
            //                              isNot: true,
            //                              operator: 'in',
            //                              value: parent?.topics?.filter(d => d.refLabTopic && !d.isDelete).map(d => d.refLabTopic?.id) || []
            //                          }]
            //                      })}
            //                      optLabel="name"
            //                      disabled={false}
            //             ></CSelect>
            //         </Form.Item>;
            // }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.topic.refLabFormula'),
            dataIndex: 'refLabTopic.refLabFormula.value',
            align: 'center',
            width: 100
        }),
        createColumnInput({
            visible: () => !viewOnly && !refExtCenterTypeKey,
            width: 100,
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.isManual'),
            dataIndex: 'isManual',
            customRender: ({ record }) => {
                if (record.isManualStd) {
                    const whereTopic = [{
                        name: 'id',
                        type: 'UUID',
                        isNot: true,
                        operator: 'in',
                        value: parent?.topics?.filter(d => d.refLabTopic && !d.isDelete).map(d => d.refLabTopic?.id)
                    }];
                    const analysisTopic = reactive({
                        refLabTopic: record.refLabTopic,
                        isManualStd: true,
                    });
                    const activeInputs = record.inputs.filter(it => !it.isDelete);
                    if (activeInputs.length && activeInputs[0]?.results) {
                        analysisTopic.n = activeInputs[0]?.results[0]?.stdN;
                        analysisTopic.c = activeInputs[0]?.results[0]?.stdC;
                        analysisTopic.m = activeInputs[0]?.results[0]?.stdM;
                        analysisTopic.mUpper = activeInputs[0]?.results[0]?.stdMBig;
                        analysisTopic.mathSymbol = activeInputs[0]?.results[0]?.stdMathSymbol;
                        analysisTopic.operatorValue = activeInputs[0]?.results[0]?.stdMathValue;
                        analysisTopic.isAccept = activeInputs[0]?.results[0]?.stdIsAccept;
                        analysisTopic.isDetected = activeInputs[0]?.results[0]?.stdIsDetect;
                    }
                    const callBack = () => {
                        record.sub = analysisTopic?.n;
                        record?.transferTos?.forEach(d=>{
                            d.sub = record.sub;
                            d.isSave = true;
                        });
                        if (parent.refSamplingProduct.refSamplingRequest.refSamplingRequestType.key == "M") {
                            record.refTopicRepeatOption = repeatOption.filter(it => it.key == 'Unrepeatable')[0];
                        } else {
                            record.refTopicRepeatOption = analysisTopic.refLabTopic?.refRepeatOption;
                        }
                        lodash.merge(record, analysisTopic)
                        generateTopicInputWithResults({ data: [record], parent });
                        record.inputs.forEach(input => {
                            upsertCountryResults({ analysisTopic: record, input, parent })
                        })
                        clearTempProperTies({ analysisTopic: record })
                    };
                    const btn = <Button class="btn-warning m-1" size="small"
                                        onClick={() => openModalFormOperator({ props: { viewOnly: false, form: analysisTopic, parent, disableTopic: false, whereTopic, labTypeKey: refLabTypeKey }, callBack })}>
                        <CIcon file="edit.svg"></CIcon>
                    </Button>;
                    return <div>{btn}</div>;
                } else {
                    return <span></span>;
                }
            },
            align: 'center'
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopic.sub'),
            dataIndex: 'sub',
            align: 'center',
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.realValue'),
            dataIndex: 'realValue',
            search: { visible: () => false },
            align: 'left',
            sorter: false,
            customRender: ({ record }) => {
                const refLabFormula = record.refLabTopic?.refLabFormula;
                const attribute = refLabFormula?.attribute;
                const results = record.inputs?.filter(d=>!d.isDelete)?.flatMap(d=>d?.results || [])?.filter(d=>!d.isDelete);
                const isNoStd = !refExtCenterTypeKey && record.isManualStd && results?.length == 0
                const inputsJsx = record?.inputs?.filter(it => it.isDelete != true)?.map(d =>
                    <Form.Item wrapperCol={{ xs: 24 }}>
                        <InputNumber
                            value={d.realValue}
                            onUpdate:value={value => {
                                d.realValue = value;
                                d.displayValue = (attribute && attribute[refLabFormula?.key]) ? attribute[refLabFormula?.key][value] : (attribute?.displayValueKey) ? d[attribute.displayValueKey] : d.displayValue;
                                d.isSave = true;
                                record.isSave = true;
                            }}
                            allowPrecision={attribute?.allowPrecision === false ? false : true}
                            maxPrecision={attribute?.maxPrecision || 2}
                            comma={false}
                            disabled={viewOnly || isNoStd}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.realValue')}
                        ></InputNumber>
                    </Form.Item>
                ) || [];
                return <div>{...inputsJsx}</div>;
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.displayValue'),
            dataIndex: 'displayValue',
            search: { visible: () => false },
            align: 'left',
            sorter: false,
            customRender: ({ record }) => {
                const inputsJsx = record.inputs?.filter(it => it.isDelete != true)?.map(d =>
                    <Form.Item wrapperCol={{ xs: 24 }}>
                        <Input
                            value={d.displayValue}
                            onUpdate:value={value => {
                                d.displayValue = value;
                                d.isSave = true;
                                record.isSave = true;
                            }}
                            disabled={viewOnly}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.displayValue')}
                        ></Input>
                    </Form.Item>
                ) || [];
                return <div>{...inputsJsx}</div>;
            }
        }),
        createColumnInlineCheckbox({
            visible: () => !refExtCenterTypeKey,
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.isShowReport'),
            dataIndex: 'isShowReport',
            items: modelRef.topics,
            useForm,
            itemsKey: 'topics',
            customRenderInputProp: () => ({ disabled: viewOnly })
        }),
        createColumnInput({
            visible: () => !refExtCenterTypeKey,
            title: () => i18n.global.t('model.samplingProductAnalysisTopic.isTransfer'),
            dataIndex: 'isTransfer',
            customRender: ({ record }) => {
                const jsx = record.transferTos?.map(d => {
                    const refLabAnalysisStatus = d.refSamplingProductAnalysis?.refLabAnalysisStatus;
                    const btn = refLabAnalysisStatus?.key !== 'Send Result' ?
                        <span>({refLabAnalysisStatus?.value})</span>
                        : <Button class="btn-info m-1" size="small"
                                  onClick={() => openModalForm({ props,
                                      analysis: d.refSamplingProductAnalysis,
                                      isShowOnlyAttachment: true
                                  })}>
                            <CIcon file="eye.svg"></CIcon>
                        </Button>;
                    return <div>
                        {btn}
                        <span>{d.refSamplingProductAnalysis?.refDepartment?.nameTh || d.refSamplingProductAnalysis?.refLabExt?.nameTh}</span>
                    </div>;
                }) || [];
                return <div>{...jsx}</div>;
            }
        })
    ];
};

export const fetchData = ({ props, data }) => {
    const fetchCriteria = props.fetchCriteria || data.fetchCriteriaAnalysisTopic;
    if (!fetchCriteria) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch(fetchCriteria)
        .then(page => Promise.all([page]))
        //.then(page => Promise.all([page, fetchStandardTopics({ props, data })]))
        .finally(() => {
            setIsLoading(false)
        });
};

export const fetchStandardTopics = ({ props, data }) => {

    /* !!! Read Me  CR 06/10/2566
    *      ทุกรายการผลิตภัณฑ์ตอนสุ่มตรวจให้ใช้มาตรฐาน LOT BY LOT ทำให้  ยกเลิก *** countryIdDof = "99999999-9999-9999-9999-999999999999" ที่เป็นมาตรฐานของสิทธิพิเศษ
    * */

    const { parent } = props;
    const promises = [];

    const labTypeKey = parent?.refLabType?.key
    const productId = parent?.refSamplingProduct?.refCompanyProduct?.refProduct?.id;
    const countryId1 = parent?.refSamplingProduct?.refCountry1?.id;
    const countryId2 = parent?.refSamplingProduct?.refCountry2?.id;
    // const countryIdDof = "99999999-9999-9999-9999-999999999999";
    const refTransferFrom = parent?.refTransferFrom;
    const samplingRequestTypeKey = parent?.refSamplingProduct?.refSamplingRequest.refSamplingRequestType?.key;

    if (!refTransferFrom && ["L", "S"].includes(samplingRequestTypeKey)) {
        data.standards = [];
        // const cid = samplingRequestTypeKey === "S" ? countryIdDof : countryId1;
        const call1 = callSearchAllLabTopicByProductIdAndCounties({ labTypeKey, productId, countryId1: countryId1 }).then(res => {
            res.forEach(d=>d.countryId = countryId1)
            data.standards?.push(...res)
        });
        promises.push(call1);

        if (countryId2) {
            // const cid = samplingRequestTypeKey === "S" ? countryIdDof : countryId2;
            const call2 = callSearchAllLabTopicByProductIdAndCounties({ labTypeKey, productId, countryId1: countryId2 }).then(res => {
                res.forEach(d=>d.countryId = countryId2)
                data.standards?.push(...res);
            })
            promises.push(call2);
        }
    }
    return Promise.all(promises);
}

export const loadDefaultForm = () => {
    const promises = [];


    promises.push(Promise.all([]));
    return Promise.all(promises);
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .finally(() => setIsLoading(false));
};

export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { id, isActive } = data.useForm.modelRef;
    if (id && has({ menuContext, key: 'canCreate' })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: 'm-1' }));
    }
    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({
            onClick: () => onClickView({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: 'canEdit' })) {
        col1.push(createButtonEdit({
            onClick: () => onClickEdit({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({ onClick: () => onClickSave({ data }), classStyle: 'm-1' }));
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({
            onClick: () => onClickActive({
                record: { id },
                callActive,
                setIsLoading: setIsLoadingApp,
                onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
            }), classStyle: 'm-1'
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({
            onClick: () => onClickArchive({
                record: { id },
                callArchive,
                setIsLoading: setIsLoadingApp,
                onClickView: () => onClickView({ record: { id }, routerPrefix })
            }), classStyle: 'm-1'
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canDelete' })) {
        col2.push(createButtonDelete({
            onClick: () => onClickDelete({
                record: { id },
                callDelete,
                setIsLoading: setIsLoadingApp,
                state,
                routerPrefix
            }), classStyle: 'm-1'
        }));
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>;
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({
                            props,
                            data,
                            refs,
                            state,
                            routerPrefix,
                            onClickView,
                            onClickEdit
                        }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        });
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, parent, useForm, refLabTypeKey, repeatOption } = props;
    const { modelRef } = useForm;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: props.parent.topics });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({
                rowSelection,
                items: props.parent.samplingProducts
            })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    if (!viewOnly) {
        data.manageExtras.push({
            visible: () => has({ menuContext, key: 'canEdit' }),
            render: () => ({
                ...createButtonCreate({
                    onClick: () => {
                        const analysisTopic = reactive({ mode: "create", isManualStd: !!parent?.refExtCenterType });
                        const whereTopic = [{
                            name: 'id',
                            type: 'UUID',
                            isNot: true,
                            operator: 'in',
                            value: parent?.topics?.filter(d => d.refLabTopic && !d.isDelete).map(d => d.refLabTopic?.id)
                        }];
                        const callBack = () => {
                            const record = createForm({ ...analysisTopic });
                            record.isShowReport = true;
                            record.sub = analysisTopic?.n;
                            if (parent.refSamplingProduct.refSamplingRequest.refSamplingRequestType.key == "M") {
                                record.refTopicRepeatOption = repeatOption.filter(it => it.key == 'Unrepeatable')[0];
                            } else {
                                record.refTopicRepeatOption = analysisTopic.refLabTopic?.refRepeatOption;
                            }
                            generateTopicInputWithResults({ data: [record], parent });
                            clearTempProperTies({ analysisTopic: analysisTopic })
                            props.parent.topics.push(record);
                        };
                        openModalFormOperator({
                            props: {
                                viewOnly: false,
                                form: analysisTopic,
                                parent,
                                disableTopic: false,
                                whereTopic,
                                labTypeKey: refLabTypeKey || modelRef?.refLabType?.key
                            },
                            callBack
                        });
                    },
                    options: { text: i18n.global.t('button.add') }
                })
            })
        });
        // data.manageExtras.push({
        //     visible: () => has({ menuContext, key: 'canEdit' }),
        //     render: () => ({
        //         ...createButtonCreate({
        //             onClick: () => openModalAnalysisTopicStandardForm({ props: { ...props, viewOnly, items:  props.parent.topics } }),
        //             options: { text: i18n.global.t('button.add') }
        //         }),
        //     }),
        // })
        data.rowActions.push({
            visible: () => has({ menuContext, key: 'canEdit' }),
            bind: { class: 'btn-danger', size: 'small', icon: () => <CIcon file="delete.svg"></CIcon> },
            text: () => i18n.global.t('button.cancel'),
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text: i18n.global.t('button.delete') }),
                    autoFocusButton: 'cancel',
                    okType: 'danger',
                    onOk: () => {
                        clearRulesStartsWith({ useForm, key: `topics` });
                        onClickDeleteAllClient({ rowSelection: { selectedRows: [record] }, items: parent.topics });
                    }
                });
            }
        });
    }

    fetchData({ props, data }).then(res => {
        const page = res[0]
        generateTopicInputWithResults({ data: page.data });
        page.data?.forEach(d => {
            const index = props.parent.topics?.findIndex(it => it.id === d.id);
            if (index === -1) {
                props.parent.topics.push(d);
            } else {
                props.parent.topics.splice(index, 1, d);
            }
        });
    });
};

export const state = reactive({
    page: createPage({ options: { select: ['**'] } }),
    tableOptions: { search: { activeKey: 'Search' } }
});
